<template>
  <div class="upgrade-rights">
    <div class="left-container">
      <div class="content">
        <div class="title">
          {{ $t('fa-bu-cheng-pian-zhi-you-yan-ping-tai') }}
        </div>
        <div class="title !text-primary my-[6px]">
          {{ $t('zuo-pin-zhong-xin') }}
        </div>
        <div class="description">
          {{
            $t(
              'ni-huan-mei-you-zai-ping-tai-fa-bu-de-cheng-pian-zuo-pin-kuai-lai-fa-bu-rang-geng-duo-de-ren-kan-dao-ni-de-zuo-pin-ba'
            )
          }}
        </div>
        <div class="flex flex-nowrap gap-x-[20px]">
          <slot name="button" />
        </div>
      </div>
    </div>
    <div class="right-container">
      <div class="slide-wrapper">
        <vue-photo-zoom-pro
          :url="getImageUrl()"
          :high-url="getImageUrl()"
          type="circle"
          :scale="2"
          :width="110"
          releaseselector="true"
        />
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import vuePhotoZoomPro from 'vue-photo-zoom-pro'
import 'vue-photo-zoom-pro/dist/style/vue-photo-zoom-pro.css'
const getImageUrl = () => {
  const url = getFeUrl(
    isGlobalVersion()
      ? '/youyan-platform/jpeg/personal-page-aboard.jpeg?t=1'
      : '/youyan-platform/png/personal-page.png?t=1'
  )
  return transformImage(url)
}
</script>
<style lang="scss" scoped>
.upgrade-rights {
  @apply w-full h-auto pt-[5vh] pb-[20vh] xl:px-[10%] 2xl:px-[12%] px-[5%] flex flex-nowrap gap-[50px] select-none justify-around transition-all;

  .left-container {
    @apply w-1/2;
    .content {
      @apply pt-[80px];
      .title {
        @apply text-[30px] text-font-1 leading-[42px] font-semibold;
      }

      .description {
        @apply text-16 leading-[24px] text-font-60 mt-[12px] mb-[30px] max-w-[450px];
      }
    }
  }
  .right-container {
    @apply w-auto;
    .slide-wrapper {
      @apply relative w-[568px] h-auto rounded-[12px] mt-[30px];
      border: 1px solid var(--back-2);
      padding-left: 60px;
      padding-top: 50px;
      background: var(--back-2);

      .card-img {
        @apply h-[380px] pt-[50px] pl-[60px] bg-back-2 rounded-[12px];
        background: var(--back-2);
      }

      .arrow {
        @apply w-[18px] h-[18px];

        &:hover {
          @apply text-primary;
        }
      }

      :deep(.slick-arrow) {
        @apply w-[34px] h-[34px] leading-[38px] text-center rounded-[50%] backdrop-blur-[16px] text-[20px];
        z-index: 1;
        color: #3d3e3e !important;
        background: var(--back-2) !important;
        // background: rgba(255, 255, 255, 0.8) !important;
        box-shadow: 0px 2px 5px 0px rgba(0, 26, 133, 0.25);
        top: calc(50% + 20px);
        display: flex !important;
        transition: all 0.1s ease;
        &::before {
          display: none;
        }

        &:hover {
          backdrop-filter: blur(1.6px);
          box-shadow: 2px 0 16px #001a851a;
          transform: translateY(-3px) scale(1.08);
        }
      }

      :deep(.vue-photo-zoom-pro) {
        @apply w-full h-full;
        // background: #ffffff;
        background: var(--back-2);
        box-shadow: 0px 2px 20px 0px rgba(81, 80, 96, 0.06);
        border-radius: 12px 0px 12px 0px;
        .img-preview {
          @apply object-cover w-full h-full rounded-[12px];
        }
      }

      .zoom {
        @apply absolute bottom-[10px] left-[10px] w-[28px] h-[28px] bg-white rounded-[50%] flex justify-center items-center cursor-pointer;
        box-shadow: 0px 2px 6px 0px rgba(86, 80, 220, 0.1);
        backdrop-filter: blur(29px);
        background: var(--back-2);
      }
    }
  }
}
</style>
